/* XECAR · Efectos de desplazamiento en fichas y colecciones con tema de marca.
   Solo se activan con JS y sin "reducir movimiento": sin JS todo queda visible. */
(() => {
  const html = document.documentElement;
  if (!html.classList.contains('xe-fx')) return;
  window.xeFxReady = true;

  /* 1 · Barra de progreso de lectura con el color de la marca */
  const bar = document.querySelector('.xe-progress');
  let ticking = false;
  const update = () => {
    ticking = false;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
    if (bar) bar.style.transform = `scaleX(${p})`;
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', update, { passive: true });

  /* 2 · Aparición escalonada de bloques al entrar en pantalla */
  const targets = document.querySelectorAll(
    'body.xe-skin .product__info-container > *, body.xe-skin .collection-hero__text-wrapper > *, body.xe-skin .xe-band__in > *'
  );
  const groups = new Map();
  targets.forEach((el) => {
    const key = el.parentElement;
    const n = groups.get(key) || 0;
    groups.set(key, n + 1);
    el.style.setProperty('--xe-d', Math.min(n, 10));
  });
  const show = (el) => el.classList.add('is-in');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach((el) => io.observe(el));
  } else {
    targets.forEach(show);
  }
  /* Seguridad: nada se queda oculto si algo falla */
  setTimeout(() => targets.forEach((el) => { if (el.getBoundingClientRect().top < window.innerHeight) show(el); }), 2500);

  update();
})();
